import {
  IdentityMelcoModelsProductListItem,
  ProductsApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useGetAllProductsList = (target?: string, sortByOption?: string, customLimit?: number) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<IdentityMelcoModelsProductListItem>({
    //  MelcoCoreModelsSharedGenericList1MelcoCoreModelsProductListItem
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    ProductsApi,
    ["getAllProducts", currentPage, pageSize, filters, sortBy(), searchQuery, target],
    async (api) => {

      let response;

      response = await api.productsGetList({
        offset: (currentPage - 1) * pageSize,
        limit: customLimit ? customLimit : pageSize,
        sortBy: sortByOption ? sortByOption : sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
        target: target ?? undefined,
      });



      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    errorComponent,
    searchQueryChange,
    ...query,
  };
};
